<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">薪资月份:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="月份:">
              <el-date-picker v-model="selectMonth" type="month" @change="getSalaryMonthDetail" placeholder="薪资月份" value-format="YYYY-MM"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">应发工资:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="基本薪资:">
              <el-input v-model="selectEmployee.basic_salary"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="绩效工资:">
              <el-input v-model="selectEmployee.salary_merit"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位津贴:">
              <el-input v-model="selectEmployee.salary_job_allowance"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="奖金:">
              <el-input v-model="selectEmployee.salary_award"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="餐补:">
              <el-input v-model="selectEmployee.salary_meal"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="话费补贴:">
              <el-input v-model="selectEmployee.salary_phone"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提成:">
              <el-input v-model="selectEmployee.commission"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="季度全勤:">
              <el-input v-model="selectEmployee.award_full_attendance"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="加班补贴:">
              <el-input v-model="selectEmployee.salary_overtime"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出差补贴:">
              <el-input v-model="selectEmployee.subsidy_out"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="销售绩效:">
              <el-input v-model="selectEmployee.sell_merit"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电销补贴:">
              <el-input v-model="selectEmployee.subsidy_telemarketing"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="季度奖金:">
              <el-input v-model="selectEmployee.quarterly_bonus"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目奖金:">
              <el-input v-model="selectEmployee.project_bonus"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">应扣工资:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="请假:">
              <el-input v-model="selectEmployee.cut_payment_personal"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="迟到早退:">
              <el-input v-model="selectEmployee.cut_payment_late"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="缺卡:">
              <el-input v-model="selectEmployee.cut_payment_miss_sign"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="旷工:">
              <el-input v-model="selectEmployee.cut_payment_absent"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代扣社保:">
              <el-input v-model="selectEmployee.withholding_social"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代扣公积金:">
              <el-input v-model="selectEmployee.withholding_fund"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代扣个税:">
              <el-input v-model="selectEmployee.withholding_tax"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">实发工资:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="薪资:">
              <el-input v-model="selectEmployee.salary_actual"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </el-scrollbar>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "PersonalSalaryDetail",
  inject: ['$fn'],
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      selectMonth:moment(new Date()).format('YYYY-MM'),
      selectEmployee:{},
      employeeAttendanceList:[]
    }
  },
  methods: {
    async getSalaryMonthDetail() {
      let params = {selectMonth:this.selectMonth}
      let rtn = await this.$http('userCenterService.getUserSalary',params);
      console.log(rtn);
      if(!rtn){
        return;
      }
      this.selectEmployee = rtn;
    },
  },
  created() {
    this.getSalaryMonthDetail();
  }
}
</script>


<style scoped lang="less">

</style>